import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ef6ca5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content nge-user-profile-content" }
const _hoisted_2 = {
  key: 0,
  class: "header"
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "email" }
const _hoisted_5 = { class: "nge-user-profile-grid" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-user-profile-grid-header" }, "Edits", -1 /* HOISTED */))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-user-profile-grid-header" }, "Cells", -1 /* HOISTED */))
const _hoisted_8 = { class: "nge-user-profile-subgrid" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-user-profile-timespan" }, "Today", -1 /* HOISTED */))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-user-profile-timespan" }, "Past 7 Days", -1 /* HOISTED */))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-user-profile-timespan" }, "All Time", -1 /* HOISTED */))
const _hoisted_12 = { class: "nge-user-profile-count" }
const _hoisted_13 = { class: "nge-user-profile-count" }
const _hoisted_14 = { class: "nge-user-profile-count" }
const _hoisted_15 = { class: "nge-user-profile-subgrid" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-user-profile-timespan" }, "Today", -1 /* HOISTED */))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-user-profile-timespan" }, "Past 7 Days", -1 /* HOISTED */))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-user-profile-timespan" }, "All Time", -1 /* HOISTED */))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-user-profile-count" }, "0", -1 /* HOISTED */))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-user-profile-count" }, "0", -1 /* HOISTED */))
const _hoisted_21 = { class: "nge-user-profile-count" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["ModalOverlay"], {
    class: "userProfile",
    onHide: _cache[1] || (_cache[1] = ($event: any) => ($setup.emit('hide')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("button", {
        class: "exit",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.emit('hide')))
      }, "×"),
      _createElementVNode("div", _hoisted_1, [
        ($setup.sessions.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString($setup.sessions[0].name), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_4, _toDisplayString($setup.sessions[0].email), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _hoisted_10,
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, _toDisplayString($setup.userInfo.editsToday) + " (" + _toDisplayString($setup.userInfo.mergesToday) + " | " + _toDisplayString($setup.userInfo.splitsToday) + ")", 1 /* TEXT */),
            _createElementVNode("div", _hoisted_13, _toDisplayString($setup.userInfo.editsThisWeek) + " (" + _toDisplayString($setup.userInfo.mergesThisWeek) + " | " + _toDisplayString($setup.userInfo.splitsThisWeek) + ")", 1 /* TEXT */),
            _createElementVNode("div", _hoisted_14, _toDisplayString($setup.userInfo.editsAllTime) + " (" + _toDisplayString($setup.userInfo.mergesAllTime) + " | " + _toDisplayString($setup.userInfo.splitsAllTime) + ")", 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _hoisted_17,
            _hoisted_18,
            _hoisted_19,
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, _toDisplayString($setup.cellsSubmitted), 1 /* TEXT */)
          ])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }))
}